<template>
  <div id="license-information">
    <b-overlay :show="loading" rounded="sm">
      <img src="/img/icons/apple-icon-72x72.png" alt="" srcset="" />
      <div class="my-2 h4">License Information</div>

      <b-table-simple bordered small>
        <b-thead head-variant="dark">
          <b-tr>
            <b-th background-color colspan="2">CUSTOMER DETAIL</b-th>
          </b-tr>
        </b-thead>

        <b-tbody>
          <b-tr>
            <b-td>License ID</b-td>
            <b-td>{{ license.detailLicense.id }}</b-td>
          </b-tr>

          <b-tr v-if="license.detailLicense.lifetime">
            <b-td>Validity</b-td>
            <b-td>Lifetime</b-td>
          </b-tr>
          <b-tr v-else>
            <b-td>Expired</b-td>
            <b-td></b-td>
          </b-tr>

          <b-tr>
            <b-td>Customer Name</b-td>
            <b-td>{{ license.customerName }}</b-td>
          </b-tr>
          <b-tr>
            <b-td>Customer Service Number</b-td>
            <b-td>{{ license.detailLicense.csn }}</b-td>
          </b-tr>
          <b-tr>
            <b-td>Site</b-td>
            <b-td>{{ license.detailLicense.site }}</b-td>
          </b-tr>
          <b-tr>
            <b-td>Number of Chimney</b-td>
            <b-td>{{ license.detailLicense.chimneysCount }}</b-td>
          </b-tr>
          <b-tr>
            <b-td>Machine ID</b-td>
            <b-td>{{ license.clientId }}</b-td>
          </b-tr>
          <b-tr>
            <b-td>Create Date</b-td>
            <b-td>{{ license.detailLicense.date }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <b-table-simple bordered small class="mt-4">
        <b-thead head-variant="dark">
          <b-tr>
            <b-th colspan="3">FEATURES</b-th>
          </b-tr>
        </b-thead>

        <b-tbody>
          <b-tr>
            <b-td class="text-center">
              <b-icon-check-circle-fill
                v-if="license.licenseId"
                variant="success"
                scale="1.4"
              />
              <b-icon-x-circle-fill v-else variant="danger" />
            </b-td>
            <b-td colspan="2">CEMS data logger</b-td>
          </b-tr>

          <b-tr>
            <b-td class="text-center">
              <b-icon-check-circle-fill
                v-if="license.licenseId"
                variant="success"
                scale="1.4"
              />
              <b-icon-x-circle-fill v-else variant="danger" />
            </b-td>
            <b-td colspan="2">Reporting system</b-td>
          </b-tr>

          <b-tr>
            <b-td class="text-center">
              <b-icon-check-circle-fill
                v-if="license.licenseId"
                variant="success"
                scale="1.4"
              />
              <b-icon-x-circle-fill v-else variant="danger" />
            </b-td>
            <b-td colspan="2">Alarm</b-td>
          </b-tr>

          <b-tr>
            <b-td class="text-center">
              <b-icon-check-circle-fill
                v-if="license.licenseId"
                variant="success"
                scale="1.4"
              />
              <b-icon-x-circle-fill v-else variant="danger" />
            </b-td>
            <b-td colspan="2">Telegram notification</b-td>
          </b-tr>

          <b-tr>
            <b-td class="text-center">
              <b-icon-check-circle-fill
                v-if="license.detailLicense.sispek"
                variant="success"
                scale="1.4"
              />
              <b-icon-x-circle-fill v-else variant="danger" scale="1.4" />
            </b-td>
            <b-td colspan="2">SISPEK API client</b-td>
          </b-tr>

          <b-tr v-if="license.detailLicense.siplah">
            <b-td class="text-center">
              <b-icon-check-circle-fill variant="success" scale="1.4" />
            </b-td>
            <b-td colspan="2">SIPLAH API client</b-td>
          </b-tr>

          <b-tr>
            <b-td class="text-center">
              <b-icon-check-circle-fill
                v-if="license.licenseId"
                variant="success"
                scale="1.4"
              />
              <b-icon-x-circle-fill v-else variant="danger" />
            </b-td>
            <b-td>Modbus TCP/IP communication driver</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </b-overlay>
  </div>
</template>

<script>
import { getLicense } from '@/api/ping'
export default {
  data() {
    return {
      license: {
        detailLicense: {},
      },
      loading: false,
    }
  },
  created() {
    this.getLicese()
  },
  methods: {
    async getLicese() {
      getLicense()
        .then((lic) => {
          this.license = lic
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style>
#license-information {
  border: 1px solid #dadada;
  width: 210mm !important;
  height: 297mm !important;
  padding: 2cm 1cm !important;
  margin: 1rem auto !important;
}
[background-color] {
  z-index: 0;
  position: relative;
  -webkit-print-color-adjust: exact !important;
}

@media print {
  @page {
    size: A4 portrait !important;
  }
  @page :left {
    margin-left: 0cm;
  }
  @page :right {
    margin-left: 0cm;
  }

  #license-information {
    border: unset;
    width: unset;
    height: unset;
    /* margin: unset !important; */

    /* print-color-adjust: exact !important; */
    -webkit-print-color-adjust: exact !important;
  }

  [background-color] {
    z-index: 0;
    position: relative;
    -webkit-print-color-adjust: exact !important;
  }
}
</style>
